import React from "react";

import { AccordionItemType } from "./Accordion.types";
import AccordionItem from "./AccordionItem";
import useManageAccordion from "./hooks/useManageAccordion";

type Props = {
  items: AccordionItemType[];
  multipleExpand?: boolean;
  animated?: boolean;
  onClick?: () => void;
};

const Accordion = ({ items, multipleExpand, animated, onClick }: Props) => {
  const { handleItemClick, itemsState } = useManageAccordion({
    items,
    multipleExpand,
    onClick,
  });

  return (
    <div>
      {items.map((item, index) => (
        <AccordionItem
          key={item.id}
          index={index}
          onClick={handleItemClick}
          item={item}
          isExpanded={itemsState[item.id]}
          animated={animated}
        />
      ))}
    </div>
  );
};

export default Accordion;
